import { DEFAULT_TIMEZONE } from '@constants/datetime';
import { formatTimeToBackend, toBackendWithTimezone } from '@utils/map-date/to-backend';

export const isDateLessThan = ({
  eventStartDate,
  eventEndDate,
  startTime,
  startDate,
  endTime,
  endDate,
  message,
  messageTimeBefore,
  messageTimeEnd,
  timezone = DEFAULT_TIMEZONE,
  isEqualInvalid = true,
}: {
  eventStartDate?: moment.Moment;
  eventEndDate?: moment.Moment;
  startTime: string;
  startDate: moment.Moment | null;
  endTime: string;
  endDate: moment.Moment | null;
  message: string;
  messageTimeBefore?: string;
  messageTimeEnd?: string;
  timezone: string;
  isEqualInvalid?: boolean;
}) => {
  if (!startDate || !endDate) {
    return undefined;
  }

  try {
    const startingTime = formatTimeToBackend(startDate, startTime, timezone || DEFAULT_TIMEZONE);
    const endingTime = formatTimeToBackend(endDate, endTime, timezone || DEFAULT_TIMEZONE);

    if (eventStartDate) {
      const eventStartingTime = toBackendWithTimezone(eventStartDate, timezone || DEFAULT_TIMEZONE, false);
      if (startingTime < eventStartingTime) {
        return messageTimeBefore;
      }
    }

    if (eventEndDate) {
      const eventEndingTime = toBackendWithTimezone(eventEndDate, timezone || DEFAULT_TIMEZONE, false);
      if (endingTime > eventEndingTime) {
        return messageTimeEnd;
      }
    }

    if (startingTime > endingTime) {
      return message;
    }

    if (isEqualInvalid && startingTime === endingTime) {
      return message;
    }

    return undefined;
  } catch (_: unknown) {
    return "Couldn't format date";
  }
};
